import { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import { NavLink as RouterLink, matchPath, useLocation } from "react-router-dom";
import arrowIosForwardFill from "@iconify/icons-eva/arrow-ios-forward-fill";
import arrowIosDownwardFill from "@iconify/icons-eva/arrow-ios-downward-fill";
// material
import { alpha, useTheme, styled } from "@mui/material/styles";
import { Box, List, Collapse, ListItemText, ListItemIcon, ListItemButton } from "@mui/material";

// ----------------------------------------------------------------------

const ListItemStyle = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  position: "relative",
  textTransform: "capitalize",
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(2.5),
  color: theme.palette.text.secondary,
  "&:before": {
    top: 0,
    right: 0,
    width: 3,
    bottom: 0,
    content: "''",
    display: "none",
    position: "absolute",
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    backgroundColor: theme.palette.primary.main,
  },
}));

const ListItemIconStyle = styled(ListItemIcon)({
  width: 22,
  height: 22,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.func,
};

function NavItem({ item, active }) {
  const theme = useTheme();
  const isActiveRoot = active(item.path);
  let { title, path, icon, info, children: c1 } = item;
  const [open, setOpen] = useState(isActiveRoot);
  // const [open2, setOpen2] = useState(false);
  const [c1Path, setC1Path] = useState();

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const handleOpen2 = (path) => {
    // setOpen2((prev) => !prev);
    setC1Path(path === c1Path ? "" : path);
  };

  const activeRootStyle = {
    color: "primary.main",
    fontWeight: "fontWeightMedium",
    bgcolor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    "&:before": { display: "block" },
  };

  const activeSubStyle = {
    color: "text.primary",
    fontWeight: "fontWeightMedium",
  };

  if (c1) {
    return (
      <>
        <ListItemStyle
          onClick={handleOpen}
          sx={{
            ...(isActiveRoot && activeRootStyle),
          }}
        >
          <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
          <ListItemText disableTypography primary={title} />
          {info && info}
          <Box component={Icon} icon={open ? arrowIosDownwardFill : arrowIosForwardFill} sx={{ width: 16, height: 16, ml: 1 }} />
        </ListItemStyle>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {c1.map((item) => {
              const { title, path, children: c2 } = item;
              const isActiveSub = active(path);
              const open2 = c1Path == path;

              // 二级菜单
              if (c2) {
                return (
                  <Fragment key={title}>
                    <ListItemStyle
                      onClick={() => handleOpen2(path)}
                      sx={{
                        // ...(isActiveRoot && activeRootStyle),
                        ...(isActiveRoot && activeSubStyle),
                      }}
                    >
                      <ListItemIconStyle>
                        <Box
                          component="span"
                          sx={{
                            width: 4,
                            height: 4,
                            display: "flex",
                            borderRadius: "50%",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: "text.disabled",
                            transition: (theme) => theme.transitions.create("transform"),
                            ...(isActiveSub && {
                              transform: "scale(2)",
                              bgcolor: "primary.main",
                            }),
                          }}
                        />
                      </ListItemIconStyle>
                      <ListItemText disableTypography primary={title} />
                      {info && info}
                      <Box component={Icon} icon={open2 ? arrowIosDownwardFill : arrowIosForwardFill} sx={{ width: 16, height: 16, ml: 1 }} />
                    </ListItemStyle>

                    <Collapse in={open2} timeout="auto" unmountOnExit sx={{ ml: 3 }}>
                      <List component="div" disablePadding>
                        {c2.map((item) => {
                          const { title, path } = item;
                          const isActiveSub = active(path);

                          return (
                            <ListItemStyle
                              key={title}
                              component={RouterLink}
                              to={path}
                              sx={{
                                ...(isActiveSub && activeSubStyle),
                              }}
                            >
                              <ListItemIconStyle>
                                <Box
                                  component="span"
                                  sx={{
                                    width: 4,
                                    height: 4,
                                    display: "flex",
                                    borderRadius: "50%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    bgcolor: "text.disabled",
                                    transition: (theme) => theme.transitions.create("transform"),
                                    // ...(isActiveSub && {
                                    //   transform: "scale(2)",
                                    //   bgcolor: "primary.main",
                                    // }),
                                  }}
                                />
                              </ListItemIconStyle>
                              <ListItemText disableTypography primary={title} />
                            </ListItemStyle>
                          );
                        })}
                      </List>
                    </Collapse>
                  </Fragment>
                );
              }

              return (
                <ListItemStyle
                  key={title}
                  component={RouterLink}
                  to={path}
                  sx={{
                    ...(isActiveSub && activeSubStyle),
                  }}
                >
                  <ListItemIconStyle>
                    <Box
                      component="span"
                      sx={{
                        width: 4,
                        height: 4,
                        display: "flex",
                        borderRadius: "50%",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "text.disabled",
                        transition: (theme) => theme.transitions.create("transform"),
                        ...(isActiveSub && {
                          transform: "scale(2)",
                          bgcolor: "primary.main",
                        }),
                      }}
                    />
                  </ListItemIconStyle>
                  <ListItemText disableTypography primary={title} />
                </ListItemStyle>
              );
            })}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <ListItemStyle
      component={RouterLink}
      to={path}
      sx={{
        ...(isActiveRoot && activeRootStyle),
      }}
    >
      <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
      <ListItemText disableTypography primary={title} />
      {info && info}
    </ListItemStyle>
  );
}

NavSection.propTypes = {
  navConfig: PropTypes.array,
};

export default function NavSection({ navConfig, ...other }) {
  const { pathname } = useLocation();
  // console.log(pathname)
  // const match = (path) => (path ? !!matchPath({ path, end: false }, pathname) : false);
  const match = (path) => (path ? !!matchPath({ path, end: path == "/" ? true : false }, pathname) : false);

  return (
    <Box {...other}>
      <List disablePadding>
        {navConfig.map((item) => (
          <NavItem key={item.title} item={item} active={match} />
        ))}
      </List>
    </Box>
  );
}
